import type { SVGProps } from "react";
export interface TvRetroIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TvRetroIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TvRetroIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.875 22v-1.5a1.125 1.125 0 0 1 2.25 0V22a1.125 1.125 0 0 1-2.25 0m12 0v-1.5a1.125 1.125 0 0 1 2.25 0V22a1.125 1.125 0 0 1-2.25 0m-10.75-5.625h8.75v-6.75h-8.75zm13.027-4.241c.32-.028.649.076.893.32.245.245.347.573.32.893q.009.076.01.153-.001.078-.01.153c.027.32-.075.647-.32.892a1.12 1.12 0 0 1-.893.32q-.075.009-.152.01a1 1 0 0 1-.154-.01 1.12 1.12 0 0 1-.89-.32 1.12 1.12 0 0 1-.322-.892l-.001-.012-.008-.14.008-.141.001-.013c-.027-.32.077-.648.321-.893a1.12 1.12 0 0 1 .89-.32 1 1 0 0 1 .155-.009l.14.007zm0-4a1.11 1.11 0 0 1 1.213 1.212q.009.076.01.154-.001.078-.01.152c.028.32-.075.65-.32.894a1.12 1.12 0 0 1-.893.32q-.075.009-.152.01-.078-.001-.154-.01a1.12 1.12 0 0 1-.89-.32 1.12 1.12 0 0 1-.322-.894l-.001-.011-.008-.141.008-.14.001-.014a1.113 1.113 0 0 1 1.211-1.212 1 1 0 0 1 .155-.01l.14.008.012.001Zm-3.938-6.94a1.125 1.125 0 0 1 1.57 1.612l-3.588 3.5A1.12 1.12 0 0 1 12 6.543c-.366.143-.79.092-1.11-.163l-.087-.076-3.59-3.5-.078-.084a1.125 1.125 0 0 1 1.563-1.603l.086.076L12 4.328zM17.124 17c0 .897-.726 1.625-1.624 1.625h-10A1.625 1.625 0 0 1 3.875 17V9c0-.897.727-1.625 1.625-1.626h10c.898 0 1.625.729 1.625 1.626v8Z"
      />
      <path
        fill={color}
        d="M20.875 8.5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v9c0 1.035.84 1.875 1.875 1.875h14c1.035 0 1.875-.84 1.875-1.875zm2.25 9A4.125 4.125 0 0 1 19 21.625H5A4.125 4.125 0 0 1 .875 17.5v-9A4.125 4.125 0 0 1 5 4.375h14A4.125 4.125 0 0 1 23.125 8.5z"
      />
    </svg>
  );
}
